export default __webpack_public_path__ + "static/media/case-1.006353c0.jpg";